import PropTypes from "prop-types";
import { RgbAlignmentReport } from "./RgbAlignmentReport";

AlignmentModal.propTypes = {
    missionUuid: PropTypes.string,
    onClose: PropTypes.func.isRequired,
};

export function AlignmentModal({ missionUuid, onClose }) {
    return (
        missionUuid && (
            <RgbAlignmentReport missionUuid={missionUuid} onClose={onClose} />
        )
    );
}
